import { useEffect } from 'react';
import CONFIG from 'configLoader';
import { getWoolfToken } from 'app/services/woolf-integration-api-service';
import auth from '@udacity/ureact-hoth';

/**
 * Load the Woolf SDK script necessary to track feedback submission activities.
 */
export function useWoolfScript(enabled: boolean): void {
  useEffect(() => {
    let script: HTMLScriptElement | null = null;

    async function initWoolf() {
      try {
        const udacityUserId = auth.getCurrentUserId();
        if (!enabled || !udacityUserId) {
          return;
        }
        const token = await getWoolfToken(udacityUserId);
        if (!token) {
          return;
        }

        const sdkOptions = { env: CONFIG.woolfEnv, widget: { renderOnInit: false } };
        script = document.createElement('script');
        script.type = 'module';
        const scriptUrl = `https://sdk.woolf.university/v1/latest?token=${token}&options=${encodeURIComponent(
          JSON.stringify(sdkOptions)
        )}`;
        script.src = scriptUrl;
        script.async = true;
        script.onerror = (error) => {
          console.error('Woolf script failed to load from URL:', scriptUrl, error);
        };
        document.body.appendChild(script);
      } catch (error) {
        console.error('Failed to init Woolf SDK', error);
      }
    }

    initWoolf();

    return () => {
      if (script && document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, [enabled]);
}
